import i18n from '@/i18n/i18n'
import { PurchasePeriodService } from '@/services/admin/PurchasePeriodService'
import { build_query, errorMessage } from '@/utilities/helpers.js'

const { t } = i18n.global

export const allowedFilters = ['city', 'region', 'crops', 'sub_categories', 'sales_channel']

export const namespaced = true

export const state = {
  purchasePeriods: null
}

export const mutations = {
  SET_PURCHASE_PERIODS(state, purchasePeriods) {
    state.purchasePeriods = purchasePeriods
  }
}

export const actions = {
  getPurchasePeriods({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      PurchasePeriodService.getPurchasePeriods(newQuery)
        .then(response => {
          commit('SET_PURCHASE_PERIODS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase_period.get_purchase_periods_error') + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  export({ dispatch }) {
    return new Promise((resolve, reject) => {
      PurchasePeriodService.export()
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.admin.purchase_period.export_success')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(error => {
          const notification = {
            type: 'danger',
            message: t('store.admin.purchase_period.export_error')
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(error)
        })
    })
  }
}
